import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { SuggestionsDirective } from '@lib/ui';
import { DialogModule, DialogService } from '@proget-shared/dialog';
import { CheckboxModule } from '@proget-shared/form/checkbox';
import { CustomValidators } from '@proget-shared/form/custom-validators';
import { FormControlErrorModule } from '@proget-shared/form/form-control-error';
import { FormHelperModule } from '@proget-shared/form/helper';
import { InputModule } from '@proget-shared/form/input';
import { TranslateModule } from '@proget-shared/translate';
import { InputLengthCounterModule } from '@proget-shared/ui/input-length-counter';

@Component({
  selector: 'lib-user-card-send-alert',
  templateUrl: './send-alert.component.html',
  styleUrls: ['./send-alert.component.scss'],
  imports: [
    ReactiveFormsModule,
    DialogModule,
    SuggestionsDirective,
    InputModule,
    InputLengthCounterModule,
    CheckboxModule,
    FormControlErrorModule,
    FormHelperModule,
    TranslateModule,
  ],
})
export class SendAlertComponent {
  protected readonly MAX_MESSAGE_LENGTH: number = 250;
  protected readonly form: FormGroup;

  private readonly dialog = inject(DialogService);

  constructor() {
    this.form = inject(FormBuilder).group({
      message: [
        '',
        [
          CustomValidators.required({ trimString: true }),
          Validators.maxLength(this.MAX_MESSAGE_LENGTH),
        ],
      ],
      vibrate: [false],
    });
  }

  protected close(): void {
    this.dialog.reject(this);
  }

  protected submit({ invalid, value }: FormGroup): void {
    if (invalid) {
      return;
    }

    this.dialog.resolve(this, {
      message: value.message,
      vibrate: value.vibrate,
    });
  }
}
